export default __webpack_public_path__ + "static/media/042-taxi driver.f5073d4a.svg";